import styled from 'styled-components';

export const ColorPickerWrapper = styled.fieldset`
  width: 50%;
`;

export const StyledInput = styled.input`
  display: none;
`;
